// extracted by mini-css-extract-plugin
export default {"leftBox":"Navbar_leftBox__XeU4G","logo":"Navbar_logo__MK0b0","mainBox":"Navbar_mainBox__FDYQS","rightBox":"Navbar_rightBox__-U1wD","hamburger":"Navbar_hamburger__luqXq"};